var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBurger = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.25 5A.75.75 0 0 1 4 4.25h8a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 5m0 3A.75.75 0 0 1 4 7.25h8a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 8M4 10.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBurger);
export default ForwardRef;